import type { MyItemsResponse, MyItemsRoleFilter } from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

/**
 * Страница «Моё» — `GET /api/my/items`.
 *
 * Кросс-пространственный список записей текущего пользователя (исполнитель
 * по user-полям и/или автор). GET → CSRF не нужен. `signal` — для отмены
 * устаревшего запроса при переключении фильтра роли.
 */
export function fetchMyItems(
  role: MyItemsRoleFilter,
  signal?: AbortSignal,
): Promise<MyItemsResponse> {
  const params = new URLSearchParams({ role, limit: '200' });
  return apiRequest<MyItemsResponse>(`/api/my/items?${params.toString()}`, {
    method: 'GET',
    signal,
  });
}
